import React from "react";
import '../Footer/Footer.css'

function Footer() {
 
    return(
        <div className="footer">
            Copyright ⓒ2022 Ain Jo. All rights reserved
        </div>
    )
}
export default Footer;
